<div class="checkout-container">
  <div class="link-holder">
    <a href="#" @click.prevent="goBack" class="link-back">
      <span class="iconfont-arrow-left"></span>
      <span class="separator"></span>
      <span class="text">{{ $t('shopping.basket.checkout.back') }}</span>
    </a>
  </div>
  <div class="checkout-holder">
    <div class="checkout-content">
      <Content ref="contentRef" />
    </div>
    <div class="checkout-aside">
      <Aside @submit="handleSubmit" />
    </div>
  </div>
</div>
